module.exports = __webpack_public_path__ + "static/venmo_logo-8aeb07124ff990910ad9915e27f47212.png";